import { render, staticRenderFns } from "./TrainingPanel.vue?vue&type=template&id=4694ef25&scoped=true&"
import script from "./TrainingPanel.vue?vue&type=script&lang=js&"
export * from "./TrainingPanel.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPanel.vue?vue&type=style&index=0&id=4694ef25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694ef25",
  null
  
)

export default component.exports